// extracted by mini-css-extract-plugin
module.exports = {"butons":"styles_butons__2pspq"};